import { AxiosResponse } from 'axios';
import DesignVersionedResource from '../DesignVersionedResource';
import { ATM } from './ATM';

export default class ATMSettingsResource extends DesignVersionedResource {
  public async get(fiId: number | string) : Promise<ATM> {
    const url = `/api/rcx/config/${fiId}/atm/date/${this.designStartDate}`;
    try {
      const response: AxiosResponse = await this.apiClient.get(url);
      return response.data.data;
    } catch (error) {
      // Will 404 if processing days has not been set up yet, so return empty ATM
      if ((error as any).response.status !== 404) {
        throw error;
      } else {
        return ATMSettingsResource.createEmptyATM(this.designStartDate);
      }
    }
  }

  public async getForDate(fiId: number | string, date: string) : Promise<ATM> {
    const url = `/api/rcx/config/${fiId}/atm/date/${date}`;
    try {
      const response: AxiosResponse = await this.apiClient.get(url);
      return response.data.data;
    } catch (error) {
      // Will 404 if processing days has not been set up yet, so return empty ATM
      if ((error as any).response.status !== 404) {
        throw error;
      } else {
        return ATMSettingsResource.createEmptyATM(date);
      }
    }
  }

  public async getMany(fiId: number | string) : Promise<ATM[]> {
    const url = `/api/rcx/config/${fiId}/atm/find-all`;
    try {
      const response: AxiosResponse = await this.apiClient.get(url);
      return response.data.data;
    } catch (error) {
      // Will 404 if processing days has not been set up yet, so return empty ATM
      if ((error as any).response.status !== 404) {
        throw error;
      } else {
        return [];
      }
    }
  }

  public async update(fiId: number | string, data:ATM): Promise<ATM> {
    const url = `/api/rcx/config/${fiId}/atm`;
    const response: AxiosResponse = await this.apiClient.put(url, data);
    return response.data.data;
  }

  public static createEmptyATM(designStartDate:string | null) : ATM {
    const thisDesignStartDate = designStartDate === null ? '1901-01-01' : designStartDate;
    return {
      designVersionId: null,
      designStartDate: `${thisDesignStartDate}`,
      terminalFeeCalculationMethod: '',
      terminalFeeModulus: '',
      atmTransactionFilter: '',
      atmRefundAggregatorSetting: '',
    };
  }
}
